const config = {
    companyId: process.env.REACT_APP_COMPANY_ID || 'GnsrqEu7CD0Vz7FCj4JsHi7PvzxUvekn',
    apiUrl: process.env.REACT_APP_API_URL || 'https://werkschoen.klant.ai/api',
    chatbotWebhook: process.env.REACT_APP_CHATBOT_WEBHOOK || 'https://hook.eu2.make.com/qr916kcqopb1tmiifadsempngzravzt7',
    whatsappNumber: process.env.REACT_APP_WHATSAPP_NUMBER || '31610712655',
    facebookLink: process.env.REACT_APP_FACEBOOK_LINK || 'https://www.facebook.com/people/werkschoennl/100095193651440/'
};

export default config;